// Dependencies
jQuery = require('jquery');
$ = require('jquery');
Popper = require('popper.js');
Cookies = require('js-cookie');

var tourJs = require('./components/tour');
window.tourJs = tourJs;

var custom_popover = require('./components/custom_popover');
window.custom_popover = custom_popover;

var Sortable = require('sortablejs');
window.Sortable = Sortable;

require('bootstrap');

require('django-superformset/src/django-superformset');

// Components
require('./components/accordion');
require('./components/accessibility');
require('./components/menu');
require('./components/tooltips');
require('./components/tree');
require('./components/form');
require('./components/formset');
require('./components/ajaxmodal');
require('./components/tour');
require('./components/onboarding');
